<template>
    <label :for="id" class="d-flex gap-1 custom-checkbox">
      <input :id="id"
             type="checkbox"
             :checked="isChecked"
             :name="name"
             @change.stop.prevent="onCheckboxChange"
             :disabled="disabled"
             :value="value"
      />
      <span class="cw-custom-checkbox"/>
      <slot/>
      <span v-if="error" class="error-checkbox">{{ error }}</span>
    </label>
</template>

<script>
export default {
  name: 'CheckboxComponent',
  props: {
    name: {
      type: String,
    },
    id: {
      type: [String, Number],
      required: true,
    },
    error: {
      type: String,
    },
    checked: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    value: {
      type: [String, Number],
    },
  },
  data() {
    return {
      isChecked: this.checked,
    };
  },
  watch: {
    checked() {
      this.isChecked = this.checked;
    },
  },
  methods: {
    onCheckboxChange(e) {
      this.isChecked = e.target.checked;
      this.$emit('checkbox:change', e);
    },
  },
};
</script>

<style scoped lang="scss">
.custom-checkbox {
  --width: 1rem;
  --height: 1rem;
  --checkbox-top-offset: 0;
  align-items: center;
  cursor: pointer;
  
  label, p {
    cursor: pointer;
    margin-bottom: 0;
  }
  
  input:disabled + label {
    filter: var(--disable-filter);
  }
}

.error-checkbox {
  width: 100%;
  color: var(--theme-error);
  font-size: .8rem;
  font-weight: 400;
}

.custom-checkbox{
  input {
    display: none;
  }
  input:checked + .cw-custom-checkbox{
    &:before {
      position: absolute;
      bottom: 80%;
      left: 0;
      width: 100%;
      height: 100%;
      content: '\2714';
      color: var(--checkbox-color, var(--settings-body-text-color));
      z-index: 2;
      font-size: 1.2rem;
    }
  }
}
.cw-custom-checkbox {
  display: block;
  width: var(--width);
  min-width: var(--width);
  height: var(--height);
  min-height: var(--height);
  border: 2px solid var(--checkbox-color, var(--settings-body-text-color-50));
  border-radius: .2rem;
  position: relative;
  margin-top: var(--checkbox-top-offset);
}
</style>
